import client from "./client";

export default {
  login(headers) {
    return client.withoutAuth().post("api/auth", null, null, headers);
  },
  loginUser(user) {
    let bodyFormData = {};
    bodyFormData["username"] = user.username;
    bodyFormData["password"] = user.password;
    bodyFormData["smsCode"] = user.number;
    return client
      .withoutAuth()
      .post("womapi/api/account/login", {}, bodyFormData);
  },
  register(user) {
    let bodyFormData = {};
    bodyFormData["regName"] = user.regname;
    bodyFormData["regMail"] = user.regmail;
    bodyFormData["regCompany"] = user.regcompany;
    bodyFormData["regPassword"] = user.regpass;
    bodyFormData["regPasswordConfirm"] = user.regpassconfirm;
    bodyFormData["regPhone"] = user.regphone;
    return client
      .withoutAuth()
      .post("womapi/api/account/register", {}, bodyFormData);
  },
  forgotPassword(user) {
    let bodyFormData = {};
    bodyFormData["username"] = user.username;
    return client
      .withoutAuth()
      .post("womapi/api/account/forgotpassword", bodyFormData);
  },
  userInfo() {
    return client.withAuth().get("womapi/api/input");
  },
  setUserinfo(user) {
    let bodyFormData = {};
    bodyFormData["Name"] = user.name;
    bodyFormData["Email"] = user.email;
    bodyFormData["Filter"] = user.filter;
    return client
      .withAuth()
      .post("womapi/api/account/setuserinfo", {}, bodyFormData);
  },
  setPasswordinfo(password) {
    let bodyFormData = {};
    bodyFormData["oldpass"] = password.password;
    bodyFormData["newpass1"] = password.newpassword;
    bodyFormData["newpass2"] = password.newpasswordRepeat;
    return client
      .withAuth()
      .post("womapi/api/account/setpassword", bodyFormData);
  },
};
